/**
 *  @file src/utils/poller.js
 *  @description Polling mechanism. Sets up an interval at which a given callback is called.
 */
export default class Poller {

    /**
     *  @constructor
     *  @param {function} callback - Callback method called when interval expires. Callback should
     *                               return true/false. False will stop interval.
     *  @param {number} interval - interval in milliseconds.
     *  @param {object} options - Options.
     * 
     *  Available options:
     *  @param {boolean} options.startWithCallback - True to invoke callback BEFORE starting interval.
     *  @param {boolean} options.startPaused - True to set poller paused on startup.
     */
    constructor(callback, interval, options=null) {
        this._callback = callback;
        this._interval = interval;
        this._pause = false;
        this._handle = null;
        this._startWithCallback = false;

        this._internalCallback = () => {
            if (!this._pause) {
                var result = this._callback();
                if (result) {
                    this._handle = setTimeout(this._internalCallback, this._interval);
                }
            } else {
                this._handle = setTimeout(this._internalCallback, this._interval);
            }
        }

        if (options && options.startWithCallback) {
            this._startWithCallback = options.startWithCallback;
        }

        if (options && options.startPaused) {
            this._pause = true;
        }
    }

    /**
     *  Start the polling mechanism
     */
    start() {
        if (this._startWithCallback) {
            if (!this._pause) {
                var result = this._callback();
                if (!result) {
                    return;
                }
                
            }
        }
        this._handle = setTimeout(this._internalCallback, this._interval);
    }

    /**
     *  Stop/clear the polling mechanism
     */
    stop() {
        if (this._handle) {
            clearTimeout(this._handle)
        }
    }

    /**
     *  Pause the polling mechanism. This does not stop the interval polling, but
     *  simply suppresses invocation of the callback.
     */
    pause(val) {
        this._pause = val;
    }

    /**
     *  SET interval
     *  @param {number} - defined interval in milliseconds.
     */
    set interval(val) {
        this._interval = val;
        this.stop();
        this.start();
    }

    /**
     *  GET interval
     *  @return {number} - defined interval in milliseconds.
     */
    get interval() {
        return this._interval;
    }

    /**
     *  SET callback method
     *  @param {func} val - callback function.
     */
    set callback(val) {
        this._callback = val;
    }
}
